import React, { Fragment } from "react";
import PropTypes from "prop-types";

import {
  getTranslatedValue,
  translateStatic,
} from "../../../../helpers/translationHelper";
import * as theme5Styles from "../../scss/theme5.module.scss";

// import resort from "../../images/resort-icon.svg";

const Feature = ({ services, amenities, locale, defaultLocale }) => {
  return (
    <Fragment>
      <h3>{translateStatic("features", locale, defaultLocale)}</h3>
      <div className={`${theme5Styles.propFeatures}`}>
        {services.map((service) => {
          return (
            <div className={theme5Styles.colm} key={service.id}>
              {/* <span className={theme5Styles.ico}>
                                    <img alt="image" src={resort} />
                                </span> */}
              <span className={theme5Styles.nm}>
                {getTranslatedValue(
                  service.translations,
                  "name",
                  locale,
                  defaultLocale
                )}
              </span>
            </div>
          );
        })}
        {amenities.map((amenity) => {
          return (
            <div className={theme5Styles.colm} key={amenity.id}>
              {/* <span className={theme5Styles.ico}>
                                    <img alt="image" src={resort} />
                                </span> */}
              <span className={theme5Styles.nm}>
                {getTranslatedValue(
                  amenity.translations,
                  "name",
                  locale,
                  defaultLocale
                )}
              </span>
            </div>
          );
        })}
      </div>
    </Fragment>
  );
};

Feature.propTypes = {
  services: PropTypes.array.isRequired,
  amenities: PropTypes.array.isRequired,
  locale: PropTypes.string.isRequired,
  defaultLocale: PropTypes.string.isRequired,
};

export default Feature;
